export default __webpack_public_path__ + "static/media/NEXT_ART_Light.c6eac1e4.otf";